import { render, staticRenderFns, recyclableRender, components } from "./error-question.vue?vue&type=template&id=27e1dd50&scoped=true&"
var renderjs
import script from "./error-question.vue?vue&type=script&lang=js&"
export * from "./error-question.vue?vue&type=script&lang=js&"
import style0 from "./error-question.vue?vue&type=style&index=0&id=27e1dd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1dd50",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/error-question.vue"
export default component.exports